import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';

const SKIP_URL_PARTS = [
  '/api/auth/v1/cognito/sce/user-pools',
  '/auth/exchange',
  'api/auth/v1/token/exchange',
  '/oauth2/',
  '/callback-signout',
];

function shouldSkip(url: string): boolean {
  return SKIP_URL_PARTS.some((p) => url.includes(p));
}

export const AuthExchangeInterceptor: HttpInterceptorFn = (req, next) => {
  if (shouldSkip(req.url)) return next(req);

  const auth = inject(AuthService);
  const header = auth.getExchangeAuthHeader();

  if (!header) {
    return next(req);
  }

  const authReq = req.clone({ setHeaders: { Authorization: header } });
  return next(authReq);
};
